import { Component, inject } from '@angular/core';
import { AuthService } from '../../core/auth/auth.service';

@Component({
  selector: 'ks-admin-shell',
  standalone: false,
  templateUrl: './admin-shell.component.html',
  styleUrl: './admin-shell.component.scss',
})
export class AdminShellComponent {
  private readonly auth = inject(AuthService);
  readonly user    = this.auth.user;
  readonly isAdmin = this.auth.isAdmin;

  displayName(): string {
    return this.user()?.name || this.user()?.email || 'Admin';
  }

  /** First letter of the first two words — "System Admin" -> "SA". */
  initials(): string {
    return this.displayName()
      .split(/[\s@._-]+/)
      .filter(Boolean)
      .slice(0, 2)
      .map(part => part.charAt(0).toUpperCase())
      .join('');
  }

  logout(): void {
    this.auth.logout();
  }
}
